import { useEffect, useState } from 'react';

export const useScrollPosition = (): number => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const updatePosition = () => {
      const position = Math.max(
        window.pageYOffset || 0,
        document.documentElement.scrollTop || 0,
        document.body.scrollTop || 0,
      );
      setScrollPosition(position);
    };

    window.addEventListener('scroll', updatePosition);
    document.documentElement.addEventListener('scroll', updatePosition);
    document.body.addEventListener('scroll', updatePosition);

    updatePosition();

    return () => {
      window.removeEventListener('scroll', updatePosition);
      document.documentElement.removeEventListener('scroll', updatePosition);
      document.body.removeEventListener('scroll', updatePosition);
    };
  }, []);

  return scrollPosition;
};
